// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"877":"391f64b0","968":"3c94801f"}[chunkId] + ".chunk.css";
};